import React from 'react';
import { BookmarkedRoute } from '../types/ferry';
import { BaseRouteCard } from './BaseRouteCard';

interface ExportBookmarkItemProps {
  bookmark: BookmarkedRoute;
  language: string;
  t: any;
}

export const ExportBookmarkItem: React.FC<ExportBookmarkItemProps> = ({
  bookmark,
  language,
  t
}) => {
  return (
    <BaseRouteCard
      routeResult={bookmark.routeResult}
      selectedDate={bookmark.selectedDate}
      language={language}
      t={t}
      bookmarkedAt={bookmark.bookmarkedAt}
      className="mb-4"
    />
  );
};